import * as Sentry from "@sentry/browser";
import {isoLocales} from "../components/lib/payments/PaymentController";
import {getShopId} from "../components/lib/getShopId";
import {CurrencyCode} from "../typescript-library";

const formatCurrency = (params: {value: number, currencyCode?: CurrencyCode, fractionDigits?: number}): string => {
  let currencyCode = window.c_ActiveCurrency;
  if (params.currencyCode) {
    currencyCode = params.currencyCode;

    if (params.currencyCode !== window.c_ActiveCurrency) {
      const err = new Error("Deviating currency in 'CartDetails: DetailsListReduced'");
      err.name = "CurrencyDeviationError";
      Sentry.captureException(err);
    }
  }

  // Intl is very similar to the library that is used by ecs-api, for more infos check FormatterService.php line 69 method name: formatMoney
  // for more infos go to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  const formatter = new Intl.NumberFormat(isoLocales[getShopId()].locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: params.fractionDigits ?? 2,
    maximumFractionDigits: params.fractionDigits ?? 2,
  });

  if (currencyCode === "DKK") {
    return formatter.format(params.value).replace("kr.", "DKK");
  }

  return formatter.format(params.value);
};

export default formatCurrency;
